function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16,11 L7.5,11 C7.293,11 7.176,11.235 7.299,11.4 L8.8,13.4 C9.131,13.842 9.042,14.469 8.6,14.8 C8.157,15.131 7.531,15.042 7.2,14.6 L4.2,10.6 C4.188,10.583 4.187,10.564 4.176,10.548 C4.152,10.514 4.133,10.48 4.115,10.443 C4.093,10.401 4.078,10.358 4.063,10.312 C4.049,10.271 4.035,10.231 4.026,10.189 C4.019,10.148 4.017,10.109 4.014,10.067 C4.012,10.044 4,10.024 4,10 C4,9.976 4.012,9.956 4.014,9.933 C4.017,9.891 4.019,9.852 4.026,9.811 C4.035,9.769 4.049,9.729 4.063,9.688 C4.078,9.643 4.093,9.599 4.115,9.557 C4.133,9.52 4.152,9.486 4.176,9.452 C4.187,9.436 4.188,9.417 4.2,9.4 L7.2,5.4 C7.396,5.138 7.697,5 8.001,5 C8.209,5 8.42,5.065 8.6,5.2 C9.042,5.531 9.131,6.158 8.8,6.6 L7.299,8.6 C7.176,8.765 7.293,9 7.5,9 L16,9 C16.552,9 17,9.447 17,10 C17,10.553 16.552,11 16,11 M10,0 C4.477,0 0,4.477 0,10 C0,15.523 4.477,20 10,20 C15.523,20 20,15.523 20,10 C20,4.477 15.523,0 10,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    style: {
      "transform": "scaleX(-1)"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/next.f97b58d4.svg";
export { SvgComponent as ReactComponent };